import { SETTINGS_ACTIONS } from './settingsActionMap';
import { createScopedDispatchers } from 'shared/helpers/shared/selectHandlers/createScopedDispatchers';

const { selectLocationDispatch } = createScopedDispatchers(SETTINGS_ACTIONS, 'switch');

export const selectLocationIndicatorDispatcherHandler = (dispatch, name, locationList, specificLocationList, machineList, newSelectedLocations) =>
  selectLocationDispatch(dispatch, name, locationList, specificLocationList, machineList, newSelectedLocations);
